module.exports = __webpack_public_path__ + "img/img_brand8.f8908592.jpg";